<template>
	<form class="login-form" @submit.prevent="submit">
		<div class="fieldset">
			<field-input
				name="identifier"
				type="email"
				label="Email"
				v-model="fields.identifier"
				:errors="errors.identifier"
			/>
		</div>
		<div class="fieldset">
			<field-input
				name="password"
				type="password"
				label="Password"
				v-model="fields.password"
				:errors="errors.password"
			/>
		</div>
		<div class="fieldset">
			<submit-button v-bind="submitButton" label="Log in" />
		</div>
	</form>
</template>

<script>
import FieldInput from '@/components/shared/FieldInput'
import SubmitButton from '@/components/shared/SubmitButton'
import form from '@/mixins/form'

export default {
	name: 'login-form',
	mixins: [form.login],
	components: {
		FieldInput,
		SubmitButton
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.login-form {
	width: 100%;
	max-width: 20rem;
	.fieldset {
		margin-bottom: 2rem;
	}
	input[type='submit'] {
		@include button;
	}
}
</style>
